import React, { useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { CustomersContext } from "../providers/CustomersProvider";
import { useHistory } from "react-router-dom";
import { useEditMode } from "../customHooks/useEditMode";
import { customersRef } from "../firebase";
import Footer from "./Footer";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import "../css/settingsLists.scss";
import { AuthContext } from "../providers/AuthProvider";
import { deleteDoc, doc, setDoc } from "firebase/firestore";

const Customers = () => {
  const { user } = useContext(AuthContext);
  const customers = useContext(CustomersContext);
  const history = useHistory();

  const { inEditMode, toggleEditMode, isMarked, markItem, markedItems } =
    useEditMode();

  function editCustomer(customer) {
    let customerId = customer.uid;
    if (inEditMode) {
      markItem(customer);
    } else {
      let url = `/settings/customers/${customerId}`;
      history.push(url, { customer: customer });
    }
  }

  async function removeCustomers() {
    markedItems.forEach((uid) => {
      deleteDoc(doc(customersRef, uid)).catch((err) => {
        console.error("Error deleting customers", err);
      });
    });
    toggleEditMode();
  }

  async function addCustomer() {
    let customerId = uuidv4();

    let blankCustomer = {
      uid: customerId,
      createdBy: user.uid,
    };

    try {
      let url = `/settings/customers/${customerId}`;
      history.push(url, {
        rate: blankCustomer,
        type: "customers",
      });

      setDoc(doc(customersRef, customerId), blankCustomer);
    } catch (err) {
      console.error("Error adding customer:", err);
    }
  }

  let showBin = inEditMode && markedItems.length > 0;

  return (
    <div className="customersPage">
      <Footer back={true} title="Customer" backTo={"/"}>
        <button
          title="Edit"
          onClick={() => toggleEditMode(document.body)}
          className="adder"
        >
          <EditIcon style={{ fontSize: 25 }} />
        </button>
        {showBin ? (
          <button
            title="Delete Permanently"
            onClick={removeCustomers}
            className="adder"
          >
            <DeleteOutlinedIcon style={{ fontSize: 30 }} />
          </button>
        ) : (
          <button title="Add Customer" onClick={addCustomer} className="adder">
            <AddIcon style={{ fontSize: 30 }} />
          </button>
        )}
      </Footer>
      {/* <Footer title={"Customers"} back={true}>
        <button onClick={toggleEditMode} className="adder">
          ~
        </button>

        <button onClick={addCustomer} className="adder">
          @
        </button>
      </Footer> */}
      {/* <button className="addCustomer" onClick={addCustomer}>
        Add Customer
      </button>
      <button onClick={toggleEditMode}>
        edit mode <span>{String(inEditMode)}</span>
      </button> */}

      {/* {customers.length === 0 && <NoTimesheets />} */}

      <div className="settingsList">
        {customers.map((customer) => {
          let marked = isMarked(customer.uid);
          return (
            <button
              className="settingsCard"
              // style={marked ? markedItem : unmarkedItem}
              onClick={() => editCustomer(customer)}
              key={customer.uid}
            >
              <div className="cardHeader">
                <span>{customer.name}</span>
                <span></span>
                <span>{customer.accessId}</span>
              </div>
              <div className="cardBody">
                {customer.address}
                <br />
                {customer.address2}
              </div>
              <div className="cardFooter"></div>
              {marked && <div className="markedPrimary" />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Customers;
